export default "https://cdn-static.gokick.com/assets/6706629b3df14a4b3713b9aca1ff59a1c44b8347/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";